'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const IconButton_IconButton = require('../IconButton/IconButton.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const clsx__default = /*#__PURE__*/_interopDefault(clsx);
const React__default = /*#__PURE__*/_interopDefault(React);

const modalOverlay = "_modal-overlay_tg2mk_17";
const fadeIn = "_fade-in_tg2mk_1";
const fadeOut = "_fade-out_tg2mk_1";
const modal = "_modal_tg2mk_17";
const dialog = "_dialog_tg2mk_57";
const closeButton = "_close-button_tg2mk_71";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal,
	dialog: dialog,
	closeButton: closeButton
};

const ModalContent = (_a) => {
  var { children, className, isDismissable = true } = _a, props = tslib_es6.__rest(_a, ["children", "className", "isDismissable"]);
  return React__default.default.createElement(
    reactAriaComponents.ModalOverlay,
    { className: styles.modalOverlay, "data-zds": true, isDismissable },
    React__default.default.createElement(
      reactAriaComponents.Modal,
      { className: clsx__default.default(className, styles.modal), "data-zds": true, isDismissable },
      React__default.default.createElement(reactAriaComponents.Dialog, Object.assign({}, props, { className: styles.dialog, "data-zds": true }), ({ close }) => React__default.default.createElement(
        React__default.default.Fragment,
        null,
        isDismissable && React__default.default.createElement(IconButton_IconButton.IconButton, { className: styles.closeButton, name: "formX", onPress: close, variant: "ghost" }),
        children
      ))
    )
  );
};

exports.ModalContent = ModalContent;
//# sourceMappingURL=Content.cjs.js.map
